import { useTranslation } from "react-i18next";
import useDocumentTitle from "../../../hook/useDocumentTitle";

export default function Home() {
  const { t } = useTranslation("home");
  useDocumentTitle(t("title"));

  return <main className="min-h-screen flex flex-col items-center justify-center gap-4 p-8">
    <h1 className="text-4xl md:text-6xl font-semibold text-gray-900">{t("title")}</h1>
    <p className="text-lg md:text-xl text-gray-600 text-center max-w-prose">
      {t("subtitle")}
    </p>
  </main>
}
